import { Board, CURRENCY } from "../../reducers/uploadedBoard";
import { UserSummary } from "../../reducers/models/users";

export enum OrderState {
  CART_CAN_BE_ORDERED = "Cart can be ordered",
  CART_HAS_ISSUES = "Cart has issues",
  CREATED = "Created",
  ORDER_RECEIVED = "Order received",
  MANUFACTURED = "Manufactured",
  CANCELED = "Canceled",
}

export const CART_STATES = new Set([
  OrderState.CART_CAN_BE_ORDERED,
  OrderState.CART_HAS_ISSUES,
]);

export enum InvoiceState {
  INVOICE_CREATED = "Invoice created",
  INVOICE_SENT = "Invoice sent",
  INVOICE_PAID = "Invoice paid",
}

export enum PaymentState {
  HAS_BALANCE = "Has balance",
  PAID_IN_FULL = "Paid in full",
  REFUNDED = "Refunded",
}

export interface OrderItem {
  board: Board;
}

export interface OrderLinks {
  shipping_label: string | null;
  google_drive_folder: string | null;
  airtable_production_record: string | null;
}

export interface PaymentRecord {
  amount: number;
  timestamp: string;
}

export interface InvoiceDetails {
  id: string;
  state: InvoiceState;
  due_date: string | null;
  payment_link: string | null;
  invoice_pdf_url: string | null;
  order_id: string | null;
  amount: number;
  overdue: boolean;
}

export interface InvoiceSummary {
  invoices: InvoiceDetails[];
  purchase_order_number: string | null;
  purchase_order_link: string | null;
  send_invoice_to: string | null;
  additional_emails: string[];
}

export interface Order {
  id: string;
  state: OrderState;
  payment_state: PaymentState | null;
  date_accepted: string;
  datetime_refunded: string | null;
  user: UserSummary;
  order_total: number;
  balance: number;
  currency: CURRENCY;
  items: OrderItem[];
  user_was_tax_exempt: boolean;
  links: OrderLinks;
  payment_records: PaymentRecord[];
  invoice_summary: InvoiceSummary;
}

export interface OrdersResponse {
  orders: Order[];
  page: number;
  starting_index: number;
  orders_per_page: number;
  total_count: number;
}
